import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from './listsApi.js';
import { useUIStore } from '../../store/ui.store.js';

export const LISTS_KEY = ['lists'] as const;

export function useLists() {
  return useQuery({
    queryKey: LISTS_KEY,
    queryFn: api.fetchLists,
    staleTime: 60_000,
  });
}

export function useCreateList() {
  const qc = useQueryClient();
  const addToast = useUIStore((s) => s.addToast);

  return useMutation({
    mutationFn: api.createList,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: LISTS_KEY });
      addToast('List created', 'success');
    },
    onError: () => addToast('Failed to create list', 'error'),
  });
}

export function useUpdateList() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({ listId, payload }: { listId: string; payload: Parameters<typeof api.updateList>[1] }) =>
      api.updateList(listId, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: LISTS_KEY }),
  });
}

export function useDeleteList() {
  const qc = useQueryClient();
  const addToast = useUIStore((s) => s.addToast);

  return useMutation({
    mutationFn: api.deleteList,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: LISTS_KEY });
      qc.invalidateQueries({ queryKey: ['tasks'] });
      addToast('List and all its tasks deleted', 'success');
    },
    onError: () => addToast('Failed to delete list', 'error'),
  });
}
